import { type Control, Controller, type FieldPath, type FieldValues } from "react-hook-form";
import { SfaaCodeSelectInput, type SfaaCodeSelectInputProps } from "../inputs/SfaaCodeSelectInput";

export type FormSfaaCodeSelectProps<
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
> = Omit<SfaaCodeSelectInputProps, "value" | "onChange" | "error" | "invalid"> & {
	// biome-ignore lint/suspicious/noExplicitAny: legacy any
	control: Control<TFieldValues, any, TTransformedValues>;
	name: FieldPath<TFieldValues>;
	errorMessage?: string;
	hideErrorMessage?: boolean;
};

export const FormSfaaCodeSelect = <
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
>({
	name,
	control,
	errorMessage,
	hideErrorMessage = false,
	...inputProps
}: FormSfaaCodeSelectProps<TFieldValues, TTransformedValues>) => (
	<Controller
		control={control}
		name={name}
		render={({ field: { value, onChange, onBlur }, fieldState }) => (
			<SfaaCodeSelectInput
				{...inputProps}
				value={value ?? undefined}
				onChange={(next) => {
					onChange(next ?? null);
					onBlur();
				}}
				error={hideErrorMessage ? undefined : fieldState.error}
				errorMessage={errorMessage}
				invalid={hideErrorMessage && !!fieldState.error}
			/>
		)}
	/>
);
